@if (formReady) {
<form [formGroup]="teamForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="mb-3">
    <label for="name" class="form-label">{{ 'TEAM.DETAILS.NAME' | translate }}</label>
    <input type="text" class="form-control" id="name" formControlName="name" required>
    @if (teamForm.get('name')?.invalid && teamForm.get('name')?.touched) {
<div class="invalid-feedback d-block">
      {{ 'TEAM.FORM.VALIDATION.NAME_REQUIRED' | translate }}
    </div>
}
  </div>

  <div class="mb-3">
    <label for="teamType" class="form-label">{{ 'TEAM.DETAILS.TYPE' | translate }}</label>
    <select class="form-select" formControlName="teamType" id="teamType">
      @for (type of teamTypeList; track type) {
<option [value]="type">{{ type }}</option>
}
    </select>
    @if (teamForm.get('teamType')?.invalid && teamForm.get('teamType')?.touched) {
<div class="invalid-feedback d-block">
      {{ 'TEAM.FORM.VALIDATION.TEAMTYPE_REQUIRED' | translate }}
    </div>
}
  </div>

  <div class="mb-3">
    <label for="description" class="form-label">{{ 'TEAM.DETAILS.DESCRIPTION' | translate }}</label>
    <textarea class="form-control" id="description" formControlName="description" rows="3"></textarea>
     @if (teamForm.get('description')?.invalid && teamForm.get('description')?.touched) {
<div class="invalid-feedback d-block">
      {{ 'TEAM.FORM.VALIDATION.DESCRIPTION_REQUIRED' | translate }}
    </div>
}
  </div>

  <div formArrayName="roles" class="mb-4">
    <h5 class="mb-3">{{ 'TEAM.FORM.REQUIRED_ROLES' | translate }}</h5>
    @for (roleGroup of rolesFormArray.controls; track roleGroup; let i = $index) {
<div class="form-group mb-2">
      <ng-container [formGroupName]="i">
        <div class=" border rounded p-3 mb-2">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="selected" [id]="'role-' + i" (change)="onRoleCheckboxChange(i)">
            <label class="form-check-label" [for]="'role-' + i">
              {{ roleGroup.get('role')?.value.name }}
            </label>
          </div>

          @if (roleGroup.get('selected')?.value) {
<div>
            <input type="number" step="0.1" min="0.1" class="form-control form-control-sm" [id]="'fte-' + i" formControlName="required_fte" placeholder="{{ 'TEAM.FORM.FTE_PLACEHOLDER' | translate }}" [class.is-invalid]="roleGroup.get('required_fte')?.invalid && roleGroup.get('required_fte')?.touched">
            @if (roleGroup.get('required_fte')?.invalid && roleGroup.get('required_fte')?.touched) {
<div class="invalid-feedback d-block small mt-1">
              @if (roleGroup.get('required_fte')?.errors?.['required']) {
<div>{{ 'TEAM.FORM.VALIDATION.FTE_REQUIRED' | translate }}</div>
}
              @if (roleGroup.get('required_fte')?.errors?.['min']) {
<div>{{ 'TEAM.FORM.VALIDATION.FTE_POSITIVE' | translate }}</div>
}
            </div>
}
          </div>
}
        </div>
      </ng-container>
    </div>
}
  </div>

  <div formArrayName="skills" class="mt-4">
    <h5 class="mb-3">{{ 'TEAM.FORM.REQUIRED_SKILLS' | translate }}</h5>
    <div class="d-flex flex-wrap gap-2">
      @for (skillControl of skillsFormArray.controls; track skillControl; let i = $index) {

        <input class="btn-check" type="checkbox" [formControlName]="i" [id]="'skill-' + i" autocomplete="off">
        <label class="btn btn-outline-secondary rounded-pill" [for]="'skill-' + i">
          {{ skills[i].name }}
        </label>
      
}
    </div>
  </div>

  <div class="mt-4 d-flex justify-content-end border-top pt-3">
    <button type="button" class="btn btn-secondary me-2" (click)="onCancel()">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="teamForm.invalid">
      {{ isEditMode ? ('COMMON.UPDATE' | translate) : ('COMMON.SAVE' | translate) }}
    </button>
  </div>
</form>
}